<template>
    <div class="detail-info-group">
        <slot></slot>

        <div
            class="key-info"
            v-if="firstGroup"
            :class="{ last: !openReadMore && !propertyDes }"
        >
            <h2 class="detail-title">
                {{ firstGroup.nameText || firstGroup.name }}
            </h2>
            <div class="content" :class="firstRowClass">
                <p
                    v-for="(field, index) in firstGroup.fields"
                    :key="index"
                    class="info-content"
                >
                    <span class="info-title">{{ field.name }}</span>
                    <span class="info-data" v-html="field.value"></span>
                </p>
            </div>
        </div>

        <div
            class="key-info"
            v-if="propertyDes"
            :class="{ last: !openReadMore }"
        >
            <p class="detail-title">
                {{ $t('md-sold-detail.propertyDescription') }}
            </p>
            <div class="info-des">
                <p class="info-content">
                    <span class="info-data" v-html="propertyDes"></span>
                </p>
            </div>
        </div>

        <div
            v-for="(group, index) in otherGroup"
            :key="index"
            v-show="openReadMore && group.fields.length > 0"
            class="key-info"
        >
            <h2 class="detail-title">{{ group.nameText || group.name }}</h2>
            <div class="content" :class="otherRowClass">
                <p
                    v-for="(field, index) in group.fields"
                    :key="index"
                    class="info-content"
                >
                    <span class="info-title">{{ field.name }}</span>
                    <span class="info-data" v-html="field.value"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { formats, dateFormat } from '@/common/format';
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from "@/store";

import { mapState } from '@/store/helpers';
import {
    KeyDetails,
    Location,
    Interior,
    Exterior,
    Building,
    School,
    Rooms,
    Others,
    MultiUnitInfo
} from '../key-value.js';
import util from '@/common/util.js';
import { INTERCEPT_MLS } from '@/common/customize.js';
export default {
    i18next: {
        ns: 'md-sold-detail',
        // translationResourcesLoaded() {
        //     this.$emit('refresh-parent');
        // }
    },
    data: function() {
        return {};
    },
    props: {
        openReadMore: {
            default: true,
            type: Boolean
        },
        firstRowClass: {
            type: String,
            default: 'two-columns'
        },
        otherRowClass: {
            type: String,
            default: 'single-column'
        }
    },
    mounted() {
        this.onLngNsLoaded('md-sold-detail').then(() => {
            this.$emit('refresh-parent');
        })
    },
    methods: {
        getPairValues(pairs) {
            let values = [];
            for (let name in pairs) {
                let valueExp = pairs[name];
                let value;
                if (typeof valueExp == 'string') {
                    value = this.info[valueExp];
                }
                if (typeof valueExp == 'function') {
                    value = valueExp(this.info);
                }
                if (value != '' && value != undefined && value != -1) {
                    values.push({
                        name: this.$t(`md-sold-detail.${name}`),
                        value: value
                    }); 
                }
            }
            return values;
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            house: store => store.page?.house || {},
            currencySymbol: store => store.currency?.symbol,
        }),
        ...mapState({
            listingGroups: store => store.listingDetail.listingGroups,
            info: store => store.listingDetail.info || {}
        }),
        keydetails() {
            let values = this.getPairValues(KeyDetails);
            return values;
        },
        groups() {
            let groups = [
                {
                    title: this.$t('md-sold-detail.location'),
                    items: this.getPairValues(Location)
                },
                {
                    title: this.$t('md-sold-detail.interior'),
                    items: this.getPairValues(Interior)
                },
                {
                    title: this.$t('md-sold-detail.exterior'),
                    items: this.getPairValues(Exterior)
                },
                {
                    title: this.$t('md-sold-detail.building'),
                    items: this.getPairValues(Building)
                },
                {
                    title: this.$t('md-sold-detail.schools'),
                    items: this.getPairValues(School)
                },
                {
                    title: this.$t('md-sold-detail.rooms'),
                    items: this.getPairValues(Rooms)
                },
                {
                    title: this.$t('md-sold-detail.others'),
                    items: this.getPairValues(Others)
                },
                {
                    title: this.$t('md-sold-detail.multiUnitInfo'),
                    items: this.getPairValues(MultiUnitInfo)
                }
            ];
            return groups;
        },
        propertyDes() {
            return this.info.detailsDescribe;
        },
        showUpdated() {
            return (
                this.info.updateTimeLong != null ||
                this.info.createTimeLong != null ||
                this.info.chimeFirstInserted != null
            );
        },
        openHouse() {
            if (
                this.info.openHouseScheduleList &&
                this.info.openHouseScheduleList.length > 0
            ) {
                return this.info.openHouseScheduleList.join(' ');
            }
            return null;
        },
        soldFlag() {
            if (this.info.listingStatus == 'Sold') {
                return 'sold-detail';
            }
            return '';
        },
        detailDes() {
            return this.info.detailsDescribe ? this.info.detailsDescribe.replace('\n', '<br>') : '';
        },
        updatedTime() {
            return this.info.updateTimeLong ? dateFormat(
                'MM/dd/yyyy hh:mm p',
                new Date(this.info.updateTimeLong), 
                this.$pinia
            ) : '';
        },
        firstGroup() {
            let firstGroup = null
            if (this.listingGroups && this.listingGroups.length > 0) {
                const customFields = {
                    'mls listing id': {
                        mls: INTERCEPT_MLS.listingId,
                        value: this.$t('md-sold-detail.mlsListingId')
                    },
                    'sold date': {
                        mls: INTERCEPT_MLS.soldDate,
                        value: this.$t('md-sold-detail.specialSoldDate')
                    },
                    'sold price': {
                        mls: INTERCEPT_MLS.soldPrice,
                        value: this.$t('md-sold-detail.specialSoldPrice')
                    }
                };
                firstGroup = this.listingGroups[0];
                firstGroup.fields.forEach(field => {
                    let name = field.name.toLowerCase();
                    if (name == 'sold date' || name == 'leased date') {
                        if (!isNaN(field.value)) {
                            field.value = dateFormat(
                                'MM/dd/yyyy',
                                new Date(+field.value)
                            );
                        }
                    }
                    if (name == 'sold price') {
                        if (this.info.listingStatus != 'Sold') {
                            field.value = '-';
                            return;
                        }
                        if (
                            !(this.house && this.house.showListingPrice) &&
                            !(this.house && this.house.showSoldPrice)
                        ) {
                            field.value = this.$t('md-sold-detail.nondisclosure');
                            return;
                        }
                        if (this.house && this.house.showSoldPrice) {
                            field.value = formats.currency({
                                value: this.info.soldPrice,
                                noSpace: true,
                                currencySymbol: this.currencySymbol
                            });
                        } else {
                            field.value = formats.currency({ value: this.info.price, noSpace: true, currencySymbol: this.currencySymbol });
                        }
                        if (this.info.nodisclosureDes != null) {
                            field.value =
                                '$ &#xfe61;&#xfe61;&#xfe61;&#xfe61;&#xfe61; ' +
                                (this.info.nodisclosureDes
                                    ? '(' + this.info.nodisclosureDes + ')'
                                    : ''); 
                        }
                    }
                    for (let key in customFields) {
                        let customField = customFields[key];
                        if (
                            key === name &&
                            customField.mls.includes(
                                util.getValueByPath(this.info, 'mlsOrg.id', 0)
                            )
                        ) {
                            field.name = customField.value;
                        }
                    }
                });
                if (
                    this.info.listingStatus != 'Sold' || !this.showSoldPrice
                ) {
                    firstGroup.fields = firstGroup.fields.filter(
                        field => field.name.toLowerCase() != 'sold price'
                    );
                }
                if (this.info.pricePerSqft) {
                    firstGroup.fields = firstGroup.fields.filter(
                        field => field.name != 'Price per Sqft'
                    );
                }
                return firstGroup;
            }
        },
        otherGroup() {
            let otherGroup = this.listingGroups ? this.listingGroups.slice(1) : [];
            otherGroup.forEach(group => {
                if (group.fields) {
                    group.fields.forEach(field => {
                        if (
                            field.type == '1' &&
                            typeof field.value == 'string'
                        ) {
                            field.value = field.value.replace(/, */g, ', ');
                        }
                    });
                }
            });
            return otherGroup
        },
    },
    inject: ['showSoldPrice']
};
</script>
<style lang="scss" src="./detail-info-group.scss"></style>
